// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__SR4wx","Icon":"Form_Icon__GQaAH"};